import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'

import Form from './Form'
import FormEdit from './FormEdit'
import ActionGet from '../../store/action/RegisterTemplate/Fetch'
import ActionDelete from '../../store/action/RegisterTemplate/Delete'
import "../../source/util.css"
import { IsEdit, IsCreate, IsView } from '../../store/constants'
import { toast } from "react-toastify";
import ComboboxInput from "../../infra/components/formInput/ComboboxInput";
import CustomGrid from "../../infra/components/grid/custom-grid-without-search";
import ActionGetAllClient from "../../store/action/Client/FetchAll";
import ActionGetAllDivision from "../../store/action/Division/FetchAll";
import ActionGetAllSender from "../../store/action/Sender/FetchAll";
import {ClientId, SenderId} from "../../helper/HelperAuth";
import ActionGetAccessModuleIdAction from '../../store/action/AccessModule/FetchActionDispatch'
import TextInputField from '../../infra/components/formInput/CustomTextInput'
import Swal from "sweetalert2";

class Page extends Component{
    constructor(props){
        super(props)
        this.state = {
            title: "Helpdesk-CS",
            form: fromJS({
                show : false,
                actionType: '',
                item: fromJS({})
            }),
            formSearch: fromJS({
                "search": ""
            }),

            searchForm : fromJS({
                "client-id"     : '',
                "temlate-name":''
            }),

            search: fromJS([
                { widthClass:'col-sm-6', id: 'search', placeholder: 'Search', label : '', value:'' },
            ]),
            columns:[
                { className : "col-sm-1", cfield: "counter", caption: "No" },
                { className : "", field: "templateName", caption: "Name", allowSearch: true },
                { className : "", field: "categoryName", caption: "Category", allowSearch: true },
                { className : "", field: "status", caption: "Status", allowSearch: true },
                {  cfield: "action", caption: "Template Detail",allowView: false, allowEdit: false, allowDelete: false ,
                    link : fromJS([
                        {"id": "HoverTemplate","icon":"cloud_download", "label": "", "className": "btn-trans btn-sm waves-effect text-success"},
                    ])
                },
                { className : "col-sm-1", cfield: "action", caption: "Actions", allowView: false }
            ],
            form_template: fromJS([
                {value : 1 , label : "Group Template"},

            ]),
            errors: fromJS({}),
            actionId:''
        };

        this.showContent = this.showContent.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleNew = this.handleNew.bind(this);
        this.handleFind = this.handleFind.bind(this);
        this.handleViewClicked = this.handleViewClicked.bind(this);
        this.handleEditClicked = this.handleEditClicked.bind(this);
        this.handleRemoveClicked = this.handleRemoveClicked.bind(this);
        this.handleCancelForm = this.handleCancelForm.bind(this);
        this.handlePageChanged = this.handlePageChanged.bind(this);
        // this.changeAction();
    }

    componentDidMount(){
        
        this.props.actionGetAllClient()
        this.props.actionGetAccessModuleIdAction('Register Template');
    }


    handleSearch(obj){
        this.setState({ formSearch: obj });
        this.refreshGrid(1, obj);
    }

    handleCancelForm(refresh){
        if(refresh){
            this.handleFindSearch(1);
        }
        this.setState({
            form:  fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            })
        })
    }

    handleOnBindCustomAction(actionId, row){
        if(actionId=='HoverTemplate'){
            return true;

        }

        return false;
    }

    handleNew(){
        this.setState({
            form:  fromJS({
                show: true,
                actionType: IsCreate,
                item: fromJS({})
            })
        })
    }

    handleViewClicked = (value) => {
        this.setState({
            form:  fromJS({
                show: true,
                actionType: IsView,
                item: value
            })
        })
    }

    handleEditClicked = (value) => {
        if(value.get('status') != 'active') {
            toast.warn('Template not active, Edit Failed ', toast.POSITION.TOP_RIGHT);
            return false
        }
        this.setState({
            form:  fromJS({
                show: true,
                actionType: IsEdit,
                item: value
            })
        })
    }

    handlePageChanged = (value) => {
        const { formSearch } = this.state;
        this.refreshGrid(value, formSearch);
    }

    refreshGrid(page, search){
        this.handleFindSearch(page);
    }

    static getDerivedStateFromProps(props, state) {
        return null;
    }

    async handleRemoveClicked(value){
        if(value.get('status') != 'active') {
            toast.warn('Template not active, Deleted Failed ', toast.POSITION.TOP_RIGHT);
            return false
        }

        var body = {
            "data":{
                "client_id":value.get('client_id'),
                "idTemplateMessage":value.get('idTemplateMessage'),
                "name_space":value.get('namespace')
            }
        };
        //debugger
        var temp = await this.props.actionDelete(body);
        if(temp.ok){
            console.log('masuk ok');
            Swal.fire("Deleted!", "Data has been deleted.", "success");
            toast.success('Delete '+ value.get('templateName') +' Success!', toast.POSITION.TOP_RIGHT);
            this.refreshGrid(1, this.state.formSearch);
        }else{
            console.log('masuk nok');
            Swal.fire("Failed!", "Failed to delete data.", "error");
            toast.error('Delete '+ value.get('templateName') +' Failed!', toast.POSITION.TOP_RIGHT);
        }
    }

    handleChange(field, value, label) {
        var formVal = this.state.searchForm;
        formVal = formVal.set(field,value);

        this.setState({ searchForm:formVal })
    }

    handleFind(){
        this.handleFindSearch(1);
    }

    /**
    async changeAction(){
        var varActionId = "";
        var dataAkses =null;
        setTimeout(() => {
            dataAkses = this.props.accessmoduleaction;
            //debugger;
            if(dataAkses){
                varActionId=dataAkses.get("action-id");
                this.setState({actionId:varActionId});
            }
        }, 3000);

    }
     **/


    handleFindSearch(page){
        // this.changeAction();
        const {searchForm} = this.state;
        let client_id = searchForm.get('client-id');
        let template_name=searchForm.get('template-name');
        let senderIdRest = ""
        var dataAkses =this.props.accessmoduleaction;;
        var varActionId = this.state.actionId;
        if(dataAkses){
            varActionId=dataAkses.get("action-id");
            this.setState({actionId:varActionId});
            if(varActionId==5){
                senderIdRest=SenderId;
            }
        }else{
            senderIdRest=SenderId;
        }
        if(client_id == null || client_id == undefined 
            ||  client_id == [""]){
            client_id = ClientId
        }
/**     
        setTimeout(() => {
            dataAkses = this.props.accessmoduleaction;
            if(dataAkses){
                varActionId=dataAkses.get("action-id");
                this.setState({actionId:varActionId});
            }
        }, 3000);
//debugger;
        if(varActionId===5){
            senderIdRest=SenderId;
        }
 **/
        this.props.actionGet(page,this.state.sortForm, client_id,senderIdRest,template_name);
    }

    showContent(){
        var form = this.state.form;

        if(form.get('show') && form.get('actionType') === IsCreate){
            return(
                <Form
                    actionType={ form.get('actionType') }
                    item={ form.get('item') }
                    handleCancelForm={ this.handleCancelForm }
                    handleSubmitOnForm={ this.handleSubmitOnForm }
                >
                </Form>
            )
        } else if (form.get('show') && form.get('actionType') === IsEdit) {
            return(
                <FormEdit
                    actionType={ form.get('actionType') }
                    item={ form.get('item') }
                    handleCancelForm={ this.handleCancelForm }
                    handleSubmitOnForm={ this.handleSubmitOnForm }>
                </FormEdit>
            )
        } else {
            const items = this.props.templatefacebook ? fromJS(this.props.templatefacebook) : fromJS({});
            const {searchForm, errors} = this.state
            return (
                <div className="clearfix">
                    <div className="card-noborder-mid">
                        <h4>
                            Template
                        </h4>
                    </div>
                    <div className=  'card'>
                        <div className="body">
                            <div className="row">
                                <div className="col-sm-6">
                                    <ComboboxInput
                                        field='client-id'
                                        value={searchForm.get('client-id')}
                                        options={fromJS({
                                            'source': this.props.clientall,
                                            'value': 'client-id',
                                            'label': 'client-name'
                                        }) }
                                        onChange={(field, value, label) => this.handleChange(field,value,label)}
                                        placeholder="Client"
                                    />
                                </div>
                                <div className="col-sm-6">
                                            <TextInputField
                                                className="form-control-text"
                                                field={'template-name'}
                                                value={searchForm.get('template-name')}
                                                onChange={(field, value) => this.handleChange(field, value)}
                                                placeholder="Template Name"
                                                hasError={errors.has('template-name')}
                                            />
                                        </div>
                            </div>
                            <div className="row no-margin-bottom" >
                                <div className="col-sm-2">
                                    <button type="button"
                                            className="btn btn-wide btn-success"
                                            onClick={this.handleFind}>
                                        Search
                                    </button>
                                </div>
                                <div className="col-sm-1"></div>
                                <div className="col-sm-2">
                                    <button type="button"
                                            className="btn btn-wide btn-success content-add"
                                            onClick={this.handleNew}>
                                        <i className="material-icons">{'add'}</i>{'Add'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <CustomGrid
                        title="Privilege"
                        columns={ this.state.columns  }
                        items={ items }
                        search={ this.state.search }
                        handleSearch={ this.handleSearch }
                        handleViewClicked={this.handleViewClicked}
                        handleEditClicked={this.handleEditClicked}
                        handleRemoveClicked={this.handleRemoveClicked}
                        handleOnBindCustomAction={ this.handleOnBindCustomAction }
                        handlePageChanged={this.handlePageChanged}
                    >
                    </CustomGrid>
                </div>

            )
        }
    }

    render(){
        const { form } = this.state;
        const title = form.get('show') ? ( form.get('actionType') === IsCreate ? "Add Template"  : "Edit Template"  ) : "";
        return (
            <div className="clearfix">
                <div className="card-noborder">
                    <h4>
                        {title}
                    </h4>
                </div>
                {
                    this.showContent()
                }
            </div>
        );
    }
}


export default connect(
    (state) => {
        return {
            template: state.user.template,
            clientall: state.user.clientall,
            templatefacebook: state.user.templatefacebook,
            accessmoduleaction: state.user.accessmoduleaction,
        }
    },
    dispatch => bindActionCreators({
        actionGet: ActionGet,
        actionDelete: ActionDelete,
        actionGetAllClient:ActionGetAllClient,
        actionGetAllDivision: ActionGetAllDivision,
        actionGetAllSender: ActionGetAllSender,
        actionGetAccessModuleIdAction:ActionGetAccessModuleIdAction,
    }, dispatch),
)(Page);